"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HiddenCropper;

var _react = _interopRequireWildcard(require("react"));

var _CropImageModal = _interopRequireDefault(require("./CropImageModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function HiddenCropper(_ref) {
  var triggerRef = _ref.triggerRef,
      onCropped = _ref.onCropped,
      _ref$cropOptions = _ref.cropOptions,
      cropOptions = _ref$cropOptions === void 0 ? {} : _ref$cropOptions,
      _ref$outputOptions = _ref.outputOptions,
      outputOptions = _ref$outputOptions === void 0 ? {} : _ref$outputOptions,
      _ref$displayOptions = _ref.displayOptions,
      displayOptions = _ref$displayOptions === void 0 ? {} : _ref$displayOptions;
  var inputRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      imageFile = _useState4[0],
      setImageFile = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      cropState = _useState6[0],
      setCropState = _useState6[1];

  function handleFileChange(e) {
    var file = e.target.files[0];

    if (file) {
      setShowModal(true);
      setImageFile(file);
      setCropState(null);
    }
  }

  function handleConfirm(croppedFile) {
    setShowModal(false);
    setImageFile(null);
    setCropState(null);
    onCropped(croppedFile);
  }

  function handleCancel() {
    setShowModal(false);
    setImageFile(null);
    setCropState(null);
  }

  triggerRef.current = {
    trigger: function trigger() {
      inputRef.current.click();
    }
  };
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("input", {
    ref: inputRef,
    type: "file",
    value: "",
    onChange: handleFileChange,
    hidden: true
  }), _react["default"].createElement(_CropImageModal["default"], {
    show: showModal,
    imageFile: imageFile,
    value: cropState,
    onChange: setCropState,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    cropOptions: cropOptions,
    outputOptions: outputOptions,
    displayOptions: _objectSpread({}, displayOptions, {
      showRemoveButton: false
    })
  }));
}